import partial from 'transmute/partial';
import memoize from 'transmute/memoize';
import { PureComponent } from 'react';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
// @ts-expect-error js module
import { openDocument } from 'crm-activity-creator-interactions-legacy/crm_ui/zorse/zorseControls';
import { Link } from 'foundations-components/transitional/components/Link';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const errorMap = {
  400: {
    illustration: 'errors/general',
    actionLink: {
      label: 'errorPage.links.refresh',
      handler: () => window.location.reload(),
      external: false
    }
  },
  403: {
    illustration: 'keys',
    actionLink: {
      label: 'errorPage.links.learnMore',
      handler: () => openDocument('https://knowledge.hubspot.com/getting-started-with-hubspot-sales/an-overview-of-team-management#4-set-the-user-s-permissions'),
      external: true
    }
  },
  404: {
    illustration: 'errors/map',
    actionLink: {
      label: 'errorPage.links.goBack',
      handler: () => window.history.go(-1),
      external: false
    }
  },
  410: {
    illustration: 'errors/map',
    actionLink: {
      label: 'errorPage.links.goBack',
      handler: () => window.history.go(-1),
      external: false
    }
  },
  500: {
    illustration: 'errors/general',
    actionLink: {
      label: 'errorPage.links.refresh',
      handler: () => window.location.reload(),
      external: false
    }
  }
};
export default class ErrorPage extends PureComponent {
  //@ts-expect-error props

  constructor(props) {
    super(props);
    // In new code, please use ES6 spread args rather than partials
    // for easier debugging and readability:
    // (...args) => myFunction('partiallyAppliedParam', ...args)
    // @ts-expect-error TODO: Refactor to use es6 spread
    this.partial = memoize(partial);
  }
  getActionLink() {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const actionLink = errorMap[this.props.errorCode].actionLink;
    // if no link is supplied, don't show a link
    if (!actionLink) {
      return null;
    }
    return /*#__PURE__*/_jsx(Link, {
      external: actionLink.external,
      onClick: actionLink.handler,
      paddingInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: actionLink.label
      })
    });
  }
  getErrorTitle(errorCode) {
    switch (errorCode) {
      case '400':
        return 'errorPage.400.title';
      case '403':
        return 'errorPage.403.title';
      case '404':
        return 'errorPage.404.title';
      case '410':
        return 'errorPage.410.title';
      case '500':
        return 'errorPage.500.title';
      default:
        return 'errorPage.generic.error';
    }
  }
  getErrorBody(errorCode) {
    switch (errorCode) {
      case '400':
        return 'errorPage.400.body';
      case '403':
        return 'errorPage.403.body';
      case '404':
        return 'errorPage.404.body';
      case '410':
        return 'errorPage.410.body';
      case '500':
        return 'errorPage.500.body';
      default:
        return null;
    }
  }
  render() {
    const {
      errorCode = '404',
      RhumbMarker,
      'data-test-id': dataTestId
    } = this.props;
    const errorTitle = this.getErrorTitle(errorCode);
    const errorBody = this.getErrorBody(errorCode);
    return /*#__PURE__*/_jsx(ErrorMessage
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    , {
      illustration: errorMap[errorCode].illustration,
      illustrationProps: {
        width: 200
      },
      title: I18n.text(errorTitle),
      "data-error": errorCode,
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsxs("p", {
        children: [errorBody && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          "data-selenium-test": "error-message",
          message: errorBody
        }), this.getActionLink(), RhumbMarker]
      })
    });
  }
}
ErrorPage.propTypes = {
  errorCode: PropTypes.oneOf(['400', '403', '404', '410', '500']).isRequired,
  RhumbMarker: PropTypes.node,
  'data-test-id': PropTypes.string
};
ErrorPage.defaultProps = {
  errorCode: '404',
  RhumbMarker: null
};